import { styled } from "@mui/material/styles";
import Button from "@components/Button/Button";

export const CancelButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));
